(function($, duo, undefined) {

  "use strict";

  /**
  * Helper functions
  * @class Utils
  */
  class Utils {

    /**
    * Creates an instance of Utils
    */
    constructor() {
    } /* constructor */

    /**
    * Cross-browser helper for the transitionend-event
    * @readonly
    * @static
    */
    static get transitionEvent() {
      var t;
      var el = document.createElement('fakeelement');
      var transitions = {
          'transition': 'transitionend',
          'OTransition': 'oTransitionEnd',
          'MozTransition': 'transitionend',
          'WebkitTransition': 'webkitTransitionEnd'
      };
      for(t in transitions) {
        if(el.style[t] !== undefined) {
          return transitions[t];
        }
      }
    } /* transitionEvent */

    /**
    * Generate a unique ID
    * -> returns a value that can be used as a unique ID
    * @static
    */
    static get uniqueId() {
      return Math.random().toString(36).substr(2, 16);
    } /* uniqueId */

    /**
    * Check if a value is a number
    * @returns {Boolean} (true if the value is a number)
    * @static
    */
    static isNumber(value) {
      if (value === undefined) {
        return false;
      }

      value = value.replace(/,/,".");
      return !isNaN(value - parseFloat(value));
    } /* isNumber */

    /**
    * Check if a value is an integer
    * @returns {Boolean} (true if the value is an integer)
    * @static
    */
    static isInt(value) {
      var x;
      if (isNaN(value)) {
        return false;
      }
      x = parseFloat(value);
      return (x | 0) === x;
    } /* isInt */

    /**
    * Get the number of decimals
    * @returns {Number} number of decimals
    * @static
    */
    static countDecimals(value) {
      if ((value % 1) != 0) {
        return value.toString().split(".")[1].length;
      } else {
        return 0;
      }
    } /* countDecimals */

    /**
    * Check if the user has an OS "reduced motion" setting activated
    * -> use this function to determine whether or not an
    *    animation should be used
    * @static
    */
    static prefersReducedMotion() {
      if ('matchMedia' in window && window.matchMedia('(prefers-reduced-motion)').matches) {
        return true;
      }

      return false;
    } /* prefersReducedMotion */

    /**
    * Detect if the browser supports scroll-behavior: smooth
    * @returns {Boolean} true if browser supports smooth scroll
    * @static
    */
    static supportsSmoothScroll() {
      const body = document.body;
      const scrollSave = body.style.scrollBehavior;
      body.style.scrollBehavior = 'smooth';
      const hasSmooth = getComputedStyle(body).scrollBehavior === 'smooth';
      body.style.scrollBehavior = scrollSave;
      return hasSmooth;
    }

    /**
    * Detect is Internet Explorer is used
    * @returns {Boolean} true if browser is Internet Explorer
    * @static
    */
    static isIE() {
      const ua = window.navigator.userAgent;
      const msie = ua.indexOf('MSIE '); // -> IE 10 or older
      const trident = ua.indexOf('Trident/'); //-> IE 11
      return (msie > 0 || trident > 0);
    }

    /**
    * Detect if a touch screen is used (dirty check - avoid if possible)
    * @returns {Boolean} true if browser has touch
    * @static
    */
    static isTouchEnabled() {
      return ('ontouchstart' in window) || ( navigator.maxTouchPoints > 0 ) || ( navigator.msMaxTouchPoints > 0 );
    }

    /**
      * Polyfill for browsers that don't support scrollTo with smooth behavior.
      */
    static smoothScrollPolyfill(node, key, target) {
      const startTime = Date.now();
      const offset = node[key];
      const gap = target - offset;
      const duration = 1000;
      let interrupt = false;
    
      const step = () => {
        const elapsed = Date.now() - startTime;
        const percentage = elapsed / duration;

        if (interrupt) {
          return;
        }

        if (percentage > 1) {
          cleanup();
          return;
        }

        node[key] = this.easingOutQuint(0, elapsed, offset, gap, duration);
        requestAnimationFrame(step);
      };

      const cancel = () => {
        interrupt = true;
        cleanup();
      };

      const cleanup = () => {
        node.removeEventListener('wheel', cancel);
        node.removeEventListener('touchstart', cancel);
      };

      node.addEventListener('wheel', cancel, { passive: true });
      node.addEventListener('touchstart', cancel, { passive: true });

      step();

      return cancel;
    }

    /**
    * Quick test to determine if polyfill needs to be called.
    */
     static get testSupportsSmoothScroll() {
      const body = document.body;
      const scrollSave = body.style.scrollBehavior;
      body.style.scrollBehavior = 'smooth';
      const hasSmooth = getComputedStyle(body).scrollBehavior === 'smooth';
      body.style.scrollBehavior = scrollSave;
      return hasSmooth;
    }

    /**
    * Custom smoothScroll implementation with a polyfill fallback
    * in case the browser has no native support.
    */
    static smoothScroll(node, topOrLeft, horizontal, native) {
      if (native) {
        return node.scrollTo({
          [horizontal ? 'left' : 'top']: topOrLeft,
          behavior: 'smooth'
        });
      } else {
        return this.smoothScrollPolyfill(node, horizontal ? 'scrollLeft' : 'scrollTop', topOrLeft);
      }
    }

    /**
    * Returns a value along an easing bezier curve.
    */
    static easingOutQuint(x, t, b, c, d) {
      return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
    }
  } /* Utils */

  duo.Utils = Utils;

})(jQuery, window.duo = window.duo || {});
